var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-autocomplete',{attrs:{"value":this.projects.typeSelected,"items":_vm.getProjectTypes,"multiple":"","label":"Tipo de Proyecto (*)","outlined":""},on:{"change":_vm.setTypeProject}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }